export default __webpack_public_path__ + "static/media/flag-russia.08a7fe4c.svg";